import makeStringIcon from '../../../../../../components/elementIcon/makeStringIconDef';

export const ICON_PICKER_SEARCH_LOADING = 'ICON_PICKER_SEARCH_LOADING';
export const ICON_PICKER_SEARCH_SUCCESS = 'ICON_PICKER_SEARCH_SUCCESS';
export const ICON_PICKER_SEARCH_ERROR = 'ICON_PICKER_SEARCH_ERROR';
export const ICON_PICKER_RECENT_SEARCH_ADD = 'ICON_PICKER_RECENT_SEARCH_ADD';

export const RECOMMENDED_TAB_ID = 'recommended';
export const LETTERS_TAB_ID = 'letters';

export const ICON_SEARCH_COUNT = 50;
export const RECOMMENDED_SEARCH_ICON_COUNT = 8;
export const TITLE_WORD_TAB_MAX = 3;
export const RECENT_SEARCH_TAB_MAX = 2;

// Analytics records the letters tab under its legacy mode name.
export const LETTERS_ANALYTICS_QUERY = '___letters___';

const NUMBERS = [...'1234567890'];

const CHARACTERS = [...'abcdefghijklmnopqrstuvwxyz', '!', '#', '$', '%', '&', '=', '~'];

export const NUMBER_ICONS = NUMBERS.map((number) => makeStringIcon(number));
export const CHARACTER_ICONS = CHARACTERS.map((character) => makeStringIcon(character, 'strdefault'));
